import { NullableArgumentError } from '../errors';

export function assertNonNullable<T>(value: T | null | undefined, name: string): asserts value is T {
  if (!value) {
    throw new NullableArgumentError({ name, value });
  }
}
